import { t } from "./translations/phrases";

/**
 * Fired on `window` when the address this page is signed in with changes (signed in, signed out, or another address,
 * in this tab or another): what the page kept for the old address (its designs, the skins it collected) must not carry
 * over to the next one. The wallet panel says so (it checks the sign-in every couple of seconds); the emblem editor
 * listens.
 */
export const SIGNED_IN_CHANGED = "trenchio:signed-in-changed";

export interface SignedInChange {
    /** lowercase; undefined when signed out */
    readonly address: string | undefined
}

export function announceSignedIn(address: string | undefined): void {
    if (typeof window === "undefined") return;
    window.dispatchEvent(new CustomEvent<SignedInChange>(SIGNED_IN_CHANGED, { detail: { address: address?.toLowerCase() } }));
}

export function onSignedInChange(listener: (address: string | undefined) => void): void {
    if (typeof window === "undefined") return;
    window.addEventListener(SIGNED_IN_CHANGED, event => listener((event as CustomEvent<SignedInChange>).detail.address));
}

/**
 * what a player is told when the server finds them signed out (a sign-in lasts a day; or signed out in another tab).
 * The server says "Address session required", from the address sign-in that's retired: that was shown as it was
 */
export const signedOutText = (): string => t("You're signed out (a sign-in lasts a day): sign in with your wallet again, or play as a guest.");
/**
 * the same words in English, for a message passed on as an error's (walletFlow.ts): shown through tr(), which finds
 * signedOutText's words for them. Keep the two the same
 */
export const SIGNED_OUT_TEXT = "You're signed out (a sign-in lasts a day): sign in with your wallet again, or play as a guest.";
